/**
 * Phone number input that wraps `react-phone-number-input` with the
 * project's MUI form styling and a default country of Guyana.
 *
 * Accepts `value` and `onChange` directly (controlled), so it slots into
 * react-hook-form via `setValue` + `getValues` or via Controller.
 */

import React from 'react';
import { Box } from '@mui/material';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export default function PhoneField({ value, onChange, error, placeholder, defaultCountry = 'GY' }) {
    return (
        <Box
            sx={{
                marginTop: '10px',
                '& .PhoneInput': {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    height: '57px',
                    padding: '0 14px',
                    borderRadius: '8px',
                    border: `1px solid ${error ? '#d32f2f' : 'rgba(0,0,0,0.23)'}`,
                    backgroundColor: '#F5F7F9',
                    transition: 'border-color 120ms ease',
                    '&:focus-within': {
                        borderColor: error ? '#d32f2f' : '#052F5D',
                        borderWidth: '2px',
                        padding: '0 13px',
                    },
                },
                '& .PhoneInputInput': {
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    fontSize: '16px',
                    fontFamily: 'inherit',
                    color: 'inherit',
                    minWidth: 0,
                },
                '& .PhoneInputCountrySelect': {
                    cursor: 'pointer',
                    background: 'transparent',
                    border: 'none',
                    outline: 'none',
                },
                '& .PhoneInputCountryIcon': {
                    width: '24px',
                    height: '18px',
                },
            }}
        >
            <PhoneInput
                international
                countryCallingCodeEditable={false}
                defaultCountry={defaultCountry}
                value={value || ''}
                onChange={(v) => onChange(v || '')}
                placeholder={placeholder || 'Enter phone number'}
            />
        </Box>
    );
}
